import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Api } from '../../core/classes/api';
import { CampaignModel, CampaignRequestDto, DeleteCampaignResponse, GetCampaignResponse, GetCampaignsResponse, PutCampaignRequestDto, PutCampaignResponse, UpdateCampaignCredentialResponse, UpdateCampaignFormResponse,} from '../../core/models/campaign.models';

@Injectable({
  providedIn: 'root'
})
export class CampaignService extends Api {

  constructor() {
    super();
  }

  // getAll(id:string="",client:string="",name:string="",start:string="",end:string="")
  // { return this.http.get(`${this.url}/campaigns?id=${id}&client_id=${client}&name=${name}&start_date=${start}end_date=${end}`); }

  getRanking(clientId?: number | null, search?: string, dateFrom?: string, dateTo?: string) {
    const url = clientId
      ? `${this.url}/campaigns/ranking/${clientId}`
      : `${this.url}/campaigns/ranking`;

    let httpParams = new HttpParams();
    if (search && search.trim() !== '') {
      httpParams = httpParams.set('search', search.trim());
    }
    if (dateFrom) {
      httpParams = httpParams.set('date_from', dateFrom);
    }
    if (dateTo) {
      httpParams = httpParams.set('date_to', dateTo);
    }

    return this.http.get<{ success: boolean; data: any[] }>(url, { params: httpParams });
  }

  getResume(clientId?: number | null, page?: number, perPage?: number, search?: string, dateFrom?: string, dateTo?: string) {
    const url = clientId
      ? `${this.url}/campaigns/resumen/${clientId}`
      : `${this.url}/campaigns/resumen`;

    let httpParams = new HttpParams();
    if (page !== undefined) {
      httpParams = httpParams.set('page', page.toString());
    }
    if (perPage !== undefined) {
      httpParams = httpParams.set('per_page', perPage.toString());
    }
    if (search !== undefined && search.trim() !== '') {
      httpParams = httpParams.set('search', search.trim());
    }
    if (dateFrom) {
      httpParams = httpParams.set('date_from', dateFrom);
    }
    if (dateTo) {
      httpParams = httpParams.set('date_to', dateTo);
    }

    return this.http.get(url, { params: httpParams });
  }

  getRecord(client: number) { return this.http.get(`${this.url}/campaigns/record/${client}`); }

  getAll(page?: number, perPage?: number, search?: string, startDate?: string, endDate?: string, clientId?: number) {
    let httpParams = new HttpParams();
    if (page !== undefined) {
      httpParams = httpParams.set('page', page.toString());
    }
    if (perPage !== undefined) {
      httpParams = httpParams.set('per_page', perPage.toString());
    }
    if (search !== undefined && search.trim() !== '') {
      httpParams = httpParams.set('search', search.trim());
    }
    if (startDate) {
      httpParams = httpParams.set('start_date', startDate);
    }
    if (endDate) {
      httpParams = httpParams.set('end_date', endDate);
    }
    if (clientId !== undefined) {
      httpParams = httpParams.set('client_id', clientId.toString());
    }

    return this.http.get<GetCampaignsResponse>(`${this.url}/campaigns`, {
      params: httpParams
    });
  }

  getCampaignForId(id: string) {
    return this.http.get<GetCampaignResponse>(`${this.url}/campaigns/${id}`);
  }

  updateCampaignForm(id: number, data: any) {
    return this.http.put<UpdateCampaignFormResponse>(`${this.url}/campaigns/form/${id}`, data);
  }

  updateCampaignCredential(id: number, data: FormData) {
    return this.http.post<UpdateCampaignCredentialResponse>(`${this.url}/campaigns/credential/${id}`, data);
  }

  updateLandingPage(id: number, data: any) {
    return this.http.post(`${this.url}/campaigns/landing-page/${id}`, data);
  } 

  /* updateCampaignForm(id: string, payload: UpdateCampaignFormRequest) {
    return this.http.put<ApiResponse>(`${this.url}/campaigns/form/${id}`, payload);
  } */

  getCampaignForSlug(slug: string) {
    return this.http.get<GetCampaignResponse>(`${this.url}/campaigns/slug/${slug}`);
  }

  createCampaign(campaing: CampaignRequestDto) {
    return this.http.post<GetCampaignResponse>(`${this.url}/campaigns`, campaing);
  }

  updateCampaign(id: CampaignModel["id"], campaign: PutCampaignRequestDto) {
    return this.http.put<PutCampaignResponse>(`${this.url}/campaigns/${id}`, campaign);
  }

  deleteCampaign(id: CampaignModel['id']) {
    return this.http.delete<DeleteCampaignResponse>(`${this.url}/campaigns/${id}`);
  }

  downloadQr(id: CampaignModel['id']): Observable<Blob> {
    return this.http.get(`${this.url}/campaigns/${id}/download-qr`, {
      responseType: 'blob'
    });
  }

  incrementVisualizations(campaignId: number) {
    return this.http.post(
      `${this.url}/campaigns/visualizations/${campaignId}`,
      {}
    );
  }

  incrementShares(recordId: number) {
    return this.http.post(
      `${this.url}/campaigns/shares/${recordId}`,
      {}
    );
  }

  registerNativeShare(uuid: string) {
    return this.http.post(
      `${this.url}/credential-generator/${uuid}/native-share`,
      {}
    );
  }
}
